import { render, staticRenderFns } from "./OnboardingAuthenticity.vue?vue&type=template&id=116bd5ce&"
import script from "./OnboardingAuthenticity.vue?vue&type=script&lang=js&"
export * from "./OnboardingAuthenticity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports